export interface TipoContaBancariaModel {
  nomeIntegracao?: string;
  descricao?: string;
}
export const CONTA_CORRENTE: TipoContaBancariaModel = {
  nomeIntegracao: "CONTA_CORRENTE",
  descricao: "Conta Corrente",
};

export const tiposContaBancaria: TipoContaBancariaModel[] = [
  { nomeIntegracao: "CONTA_CORRENTE", descricao: "Conta Corrente" },
  { nomeIntegracao: "CONTA_POUPANCA", descricao: "Poupança" },
];
